import React from 'react';
import { Button } from 'react-bootstrap';

interface FileObject {
  endpoint: string;
  fileName: string;
  uuid: string;
  key: string;
}

export const AttachmentList = (props: any) => {
  let fileStrings = String(props.files).split(';');
  // fileStrings.splice(3, 1);

  let fileObjects: FileObject[] = [];
  fileStrings.forEach((item) => {
    try {
      let endpoint = item.substring(0, item.indexOf('amazonaws.com') + 13);
      let fileAndUuid = item.substring(item.indexOf('amazonaws.com') + 14).split('_--_');
      let uuidSplit = fileAndUuid[1].split('.');
      let fileName = fileAndUuid[0] + '.' + uuidSplit[1];
      let uuid = uuidSplit[0];
      // let key = fileAndUuid[0];
      let key = fileAndUuid.join('_--_')
      fileObjects.push({ endpoint, fileName, uuid, key });
    } catch (err) {
      
    }
  });

  return (
    <div className='col-sm-7'>
      <div className='form-inline'>
        {fileObjects.map((item, value) => {
          if (item.fileName === undefined || item.fileName === 'undefined') return null;
          return (
            <a href={`${(window as any)._env_.REACT_APP_SERVER}/po/getAttachment/${item.key}`} key={item.key} download={item.fileName}>
              <Button variant='info' className='mr-2'>
                {decodeURIComponent(item.fileName)} {<i className='fa fa-download' />}
              </Button>
            </a>
          );
        })}
      </div>
    </div>
  );
};
